import { APPARATURE_TYPES } from '../reducers/types';
import { createAction } from './common';

export const setApparatureList = createAction(
  APPARATURE_TYPES.SET_APPARATURE_LIST
);
